'use client';

// module imports
import { useSession } from 'next-auth/react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

// file imports
import { LoginForm, OAuthButton } from '@/components';

interface LoginCardProps {
  onOAuthClick: (provider: string) => void;
}

export default function LoginCard({ onOAuthClick }: LoginCardProps) {
  const router = useRouter();
  const { data: session } = useSession();

  const handleLoginSuccess = () => {
    const userType = (session?.user as any)?.userType;
    if (userType === 'admin') {
      router.replace('/admin/dashboard');
    } else {
      router.replace('/dashboard');
    }
  };

  return (
    <div className="max-w-md w-full bg-white rounded-3xl shadow-lg p-10 flex flex-col items-center">
      <Image src="/logo.png" alt="TBOS Logo" width={160} height={50} className="mb-8 w-40" priority />

      <LoginForm onSuccess={handleLoginSuccess} />

      <div className="w-full text-left mt-2">
        <Link href="/forgot-password" className="text-[#DC3545] text-sm font-medium">
          Forgot Password?
        </Link>
      </div>

      <div className="text-pink-500 text-xs mt-4">Need help?</div>

      <div className="flex items-center w-full my-6">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-4 text-gray-400 font-semibold">OR</span>
        <hr className="flex-grow border-gray-300" />
      </div>

      <button className="w-full py-3 bg-[#e92773] text-white font-bold rounded-lg hover:bg-[#c51c5b] cursor-pointer transition" onClick={() => router.push('/register')} type="button">
        Create my Account
      </button>

      <OAuthButton provider="google" onClick={() => onOAuthClick('google')}>
        Continue with Google
      </OAuthButton>

      <OAuthButton provider="linkedin" onClick={() => onOAuthClick('linkedin')}>
        Continue with LinkedIn
      </OAuthButton>
    </div>
  );
}
